import React, { Component } from 'react';
import {Link, Redirect} from 'react-router-dom';
import $ from 'jquery';
import AOS from 'aos';
import {Api} from '../../../utils/Variables';

import {Row, Col, Card} from 'react-bootstrap';

import PsContext from '../../context/PsContext';
import LOGO from '../../../assets/img/core-img/logo-small.png';

import SideNav from '../SideNav';

class Header extends Component{
	
	static contextType = PsContext;
	
	constructor(props){
		super(props);
		this.state = {
			redirectTo: '',
			isRedirect: false,
		}
		
		this.handleMenuOpenClick = this.handleMenuOpenClick.bind(this);
		this.handleMenuClose = this.handleMenuClose.bind(this);
		this.goBack = this.goBack.bind(this);
	}
	
	componentDidMount(){
		 AOS.init({
		  offset: 200,
		  duration: 600,
		  easing: 'ease-in-sine',
		  delay: 100,
		});
	}
	
	handleMenuOpenClick(){
		try{
			
			var overLay = document.getElementsByClassName("sidenav-black-overlay")[0];
			var sideBar = document.getElementById("sidenavWrapper");
			$(overLay).addClass("active");
			$(sideBar).addClass("nav-active");
		}
		catch(error){ }
	}
	
	handleMenuClose(){
		try{
			
			var overLay = document.getElementsByClassName("sidenav-black-overlay")[0];
			var sideBar = document.getElementById("sidenavWrapper");
			$(overLay).removeClass("active");
			$(sideBar).removeClass("nav-active");
		}
		catch(error){ }
	}
	
	goBack(){
		/*if(this.context.state.header.to){
			this.setState({
				redirectTo: this.context.state.header.to,
				isRedirect: true,
			});
			
		}
		else{*/
			window.history.back();
		//}
	}
	
	render(){

		if(this.context.state.logged != 'YES'){
			return(<Redirect to="/" />);
		}
		
		if(this.state.isRedirect){
			return(<Redirect to="/app" />);
		}
		
		return(
			<React.Fragment>
				<div className="header-area" id="headerArea">
				  <div className="container h-100 d-flex align-items-center justify-content-between">
					
					{this.context.state.header.back ?
					  <div className="back-button">
						<a href="javascript:;" onClick={this.goBack} >
							<svg className="bi bi-arrow-left" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
							  <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"></path>
							</svg>
						</a>
					</div> : 
					<div className="logo-wrapper">
						<Link to="/app" >
							<img src={LOGO} alt="" />
						</Link>
					</div>
					}
					
					{this.context.state.header.title ? <div className="page-heading">
					  <h5 className="mb-0"> {this.context.state.header.title} </h5>
					</div> :
					<div className="page-heading">
					  <h6 className="mb-0"> {this.context.state.company.company_name} </h6>
					</div>
					}
					
					{/*<div className="top-search-form">
					  <form action="#" method="">
						<input className="form-control" type="search" placeholder="Enter your keyword" />
						<button type="submit"><i className="fa fa-search"></i></button>
					  </form>
					</div>*/}
					
					<div className="suha-navbar-toggler d-flex flex-wrap" id="suhaNavbarToggler" onClick={this.handleMenuOpenClick} >
						<span></span>
						<span></span>
						<span></span>
					</div>
					
				  </div>
				</div>
				
				<div className="sidenav-black-overlay " onClick={this.handleMenuClose} ></div>
				
				<SideNav 
					menuClose={this.handleMenuClose} 
					role={this.context.state.user.role ? this.context.state.user.role.toLowerCase() : ''}
					{...this.props}
				/>
				
			</React.Fragment>
		);
	}
	
}
export default Header;
